import { render, staticRenderFns } from "./AnaliseViabilidade.vue?vue&type=template&id=063b179e&scoped=true"
import script from "./AnaliseViabilidade.vue?vue&type=script&lang=js"
export * from "./AnaliseViabilidade.vue?vue&type=script&lang=js"
import style0 from "./AnaliseViabilidade.vue?vue&type=style&index=0&id=063b179e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b179e",
  null
  
)

export default component.exports